var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-control custom-switch mt-3"},[_c('input',{staticClass:"custom-control-input pause-animation",attrs:{"id":"pause-animation","type":"checkbox"},on:{"change":_vm.toggleAnimation}}),_c('label',{staticClass:"custom-control-label pause-animation",attrs:{"for":"pause-animation"}},[_vm._v(" Pause Animation ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }